















import { Component, Vue, Model, Prop } from 'vue-property-decorator';

export enum ShipPredefinedStyle {
  Standard = 'ship--standard',
  Tag = 'ship--tag',
}

@Component({})
export default class Ship extends Vue {
  @Prop({ default: true }) readonly clickeable!: boolean;
  @Prop({ default: false }) readonly dense!: boolean;
  @Prop({ default: ShipPredefinedStyle.Standard })
  private predefinedStyle!: ShipPredefinedStyle;
  @Model('input', { type: Boolean }) readonly active!: boolean;

  private handleClick() {
    if (this.clickeable) {
      this.$emit('input', !this.active);
      this.$emit('ship-click');
    }
  }
}
